/* =====================================================================
   FLOW STORE — scripts do tema
   ===================================================================== */
(function () {
  'use strict';

  var T = window.FlowTheme || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Dinheiro ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Bloquear rolagem ---------- */
  var lockCount = 0;
  function lock() { lockCount++; document.body.classList.add('is-locked'); }
  function unlock() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }

  /* ---------- Gavetas ---------- */
  function openDrawer(el) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock();
    var panel = $('.drawer__panel', el);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlock();
  }

  /* Menu ☰ */
  var menuDrawer = $('[data-menu-drawer]');
  $$('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(menuDrawer);
      $$('.header__menu-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (btn.hasAttribute('data-focus-search')) {
        var input = $('#MenuSearch');
        if (input) setTimeout(function () { input.focus(); }, 120);
      }
    });
  });
  $$('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeDrawer(menuDrawer);
      $$('.header__menu-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
  });

  /* ---------- Carrinho ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function getCart() {
    return fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = count ? '(' + count + ')' : ''; });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!cartDrawer) return;
    var body = $('[data-cart-items]', cartDrawer);
    var foot = $('[data-cart-foot]', cartDrawer);
    if (!cart.item_count) {
      body.innerHTML = '<p class="drawer__empty">' + escapeHtml(T.strings.cartEmpty) + '</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + (item.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">'
        : '';
      var variant = item.product_has_only_default_variant ? '' : '<p class="mini-line__variant">' + escapeHtml(item.variant_title) + '</p>';
      var discounts = (item.discounts || []).map(function (d) {
        return '<p class="mini-line__disc">' + escapeHtml(d.title) + ' (-' + formatMoney(d.amount) + ')</p>';
      }).join('');
      var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="mini-line">' +
        '<a class="mini-line__img" href="' + item.url + '">' + img + '</a>' +
        '<div>' +
          '<a class="mini-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          variant + discounts +
          '<div class="cart-line__row">' +
            '<div class="qty qty--small">' +
              '<button type="button" data-drawer-qty="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="-"><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-drawer-qty="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="+"><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="mini-line__remove" data-drawer-qty="' + (i + 1) + '" data-to="0">' + escapeHtml(T.strings.remove) + '</button>' +
        '</div>' +
        '<div class="mini-line__price">' + was + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    var disc = $('[data-cart-discounts]', cartDrawer);
    if (disc) {
      disc.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
        return '<div class="summary-row"><span>' + escapeHtml(d.title) + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></div>';
      }).join('');
    }
    $('[data-cart-total]', cartDrawer).textContent = formatMoney(cart.total_price);
    foot.hidden = false;
  }

  function changeLine(line, quantity) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); });
  }

  function openCart() {
    getCart().then(function (cart) { renderCart(cart); openDrawer(cartDrawer); });
  }

  if (cartDrawer) {
    $$('[data-drawer-close]', cartDrawer).forEach(function (b) { b.addEventListener('click', function () { closeDrawer(cartDrawer); }); });
    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drawer-qty]');
      if (!btn) return;
      btn.disabled = true;
      changeLine(parseInt(btn.getAttribute('data-drawer-qty'), 10), parseInt(btn.getAttribute('data-to'), 10)).then(renderCart);
    });
  }

  if (T.cartType === 'drawer' && !document.querySelector('[data-cart-page]')) {
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer(cartDrawer);
    closeDrawer(menuDrawer);
    closeGift();
  });

  /* Adicionar ao carrinho (todos os formulários de produto) */
  function addToCart(form, buyNow) {
    var button = $('[data-add-button]', form);
    var label = button ? (button.querySelector('[data-add-label]') || button) : null;
    var original = label ? label.innerHTML : '';
    if (button) { button.disabled = true; }
    if (label && !buyNow) label.textContent = T.strings.adding;
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
        if (buyNow) { window.location.href = '/checkout'; return; }
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        if (T.cartType === 'drawer') { openCart(); } else { window.location.href = T.routes.cart || '/cart'; }
      })
      .catch(function (err) { alert(err.message); })
      .then(function () {
        if (button) button.disabled = false;
        if (label && !buyNow) label.innerHTML = original;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, false);
  });

  /* ---------- Página do carrinho ---------- */
  var cartPage = $('[data-cart-page]');
  if (cartPage) {
    cartPage.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      btn.disabled = true;
      changeLine(parseInt(btn.getAttribute('data-line-change'), 10), parseInt(btn.getAttribute('data-qty-to'), 10))
        .then(function () { window.location.reload(); });
    });
    var promo = $('[data-promo-form]', cartPage);
    if (promo) {
      promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (promo.code.value || '').trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(T.routes.cart || '/cart');
      });
    }
  }

  /* Ordenar coleção */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Página de produto ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var qtyInput = $('[data-quantity]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var buyNowBtn = $('[data-buy-now]', section);
    var bundles = $('[data-bundles]', section);
    var current = product.variants.filter(function (v) { return String(v.id) === (idInput ? idInput.value : ''); })[0] || product.variants[0];

    /* Galeria */
    var viewport = $('[data-gallery-viewport]', section);
    var slides = viewport ? $$('.gallery__slide', viewport) : [];
    var dots = $$('.gallery__dot', section);
    var thumbs = $$('[data-thumb]', section);
    function goTo(index) {
      if (!viewport || !slides[index]) return;
      viewport.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function activeIndex() {
      if (!viewport) return 0;
      return Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth));
    }
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        var i = activeIndex();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
      var prev = $('[data-gallery-prev]', section);
      var next = $('[data-gallery-next]', section);
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, activeIndex() + 1)); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    }
    function showMedia(mediaId) {
      if (!mediaId) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    }

    /* Preços */
    function setPrices(variant) {
      $$('[data-price]', section).forEach(function (box) {
        var cur = $('[data-price-current]', box);
        var cmp = $('[data-price-compare]', box);
        var badge = $('[data-price-badge]', box);
        if (cur) cur.textContent = formatMoney(variant.price);
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        box.classList.toggle('price--sale', !!sale);
        if (cmp) { cmp.hidden = !sale; cmp.textContent = sale ? formatMoney(variant.compare_at_price) : ''; }
        if (badge) {
          badge.hidden = !sale;
          if (sale) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            badge.textContent = (badge.getAttribute('data-label') || 'Save') + ' ' + pct + '%';
          }
        }
      });
      if (bundles) {
        var compare = Math.max(variant.compare_at_price || 0, variant.price);
        $$('[data-bundle]', bundles).forEach(function (card) {
          var q = parseInt(card.getAttribute('data-bundle'), 10);
          var off = parseInt(card.getAttribute('data-off'), 10) || 0;
          var total = Math.round(variant.price * q * (100 - off) / 100);
          var was = compare * q;
          $('[data-bundle-total]', card).textContent = formatMoney(total);
          var w = $('[data-bundle-was]', card);
          w.hidden = was <= total;
          w.textContent = formatMoney(was);
          var each = $('[data-bundle-each]', card);
          each.textContent = each.textContent.replace(/^[^/]+/, formatMoney(Math.round(total / q)) + ' ');
        });
      }
      var sp = $('[data-sticky-price]', section);
      if (sp) sp.textContent = formatMoney(variant.price * (qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1));
    }

    function setAvailability(variant) {
      var ok = variant && variant.available;
      if (addBtn) addBtn.disabled = !ok;
      if (buyNowBtn) buyNowBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = ok ? (addLabel.getAttribute('data-label') || T.strings.addToCart) : (variant ? T.strings.soldOut : T.strings.unavailable);
    }

    /* Variantes */
    var picker = $('[data-variant-picker]', section);
    if (picker) {
      picker.addEventListener('change', function () {
        var selected = [];
        $$('fieldset', picker).forEach(function (fs, i) {
          var checked = $('input:checked', fs);
          selected[i] = checked ? checked.value : null;
          var label = $('[data-option-value="' + i + '"]', picker);
          if (label && checked) label.textContent = checked.value;
        });
        var variant = product.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        })[0];
        setAvailability(variant);
        if (!variant) return;
        current = variant;
        if (idInput) idInput.value = variant.id;
        setPrices(variant);
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    /* Kits Single/Duo/Trio */
    function syncBundle() {
      if (!bundles || !qtyInput) return;
      var checked = $('input:checked', bundles);
      qtyInput.value = checked ? checked.value : 1;
      var sp = $('[data-sticky-price]', section);
      if (sp && checked) sp.textContent = $('[data-bundle-total]', checked.closest('[data-bundle]')).textContent;
    }
    if (bundles) { bundles.addEventListener('change', syncBundle); syncBundle(); }

    /* Seletor de quantidade simples */
    var qtyBox = $('[data-qty]', section);
    if (qtyBox && qtyInput) {
      var visible = $('[data-qty-input]', qtyBox);
      var set = function (n) { n = Math.max(1, n || 1); visible.value = n; qtyInput.value = n; };
      $('[data-qty-minus]', qtyBox).addEventListener('click', function () { set(parseInt(visible.value, 10) - 1); });
      $('[data-qty-plus]', qtyBox).addEventListener('click', function () { set(parseInt(visible.value, 10) + 1); });
      visible.addEventListener('change', function () { set(parseInt(visible.value, 10)); });
    }

    /* Buy Now: adiciona e vai direto ao checkout */
    if (buyNowBtn && form) buyNowBtn.addEventListener('click', function () { addToCart(form, true); });

    /* Barra fixa de compra */
    var sticky = $('[data-sticky-buy]', section);
    var buyBox = $('[data-buy]', section);
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var footer = document.querySelector('.footer');
      var buyVisible = true, footerVisible = false;
      var update = function () {
        var show = !buyVisible && !footerVisible && buyBox.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-buy', show);
      };
      new IntersectionObserver(function (entries) { buyVisible = entries[0].isIntersecting; update(); }).observe(buyBox);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (form) addToCart(form, false);
      });
    }

    setPrices(current);
  });

  /* "Like it? Buy Now": sobe até a área de compra */
  $$('[data-scroll-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector('[id^="ProductBuy-"]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Avaliações ---------- */
  $$('[data-review-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('aria-controls'));
      if (!form) return;
      form.hidden = !form.hidden;
      btn.setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  $$('[data-reviews-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = btn.closest('section').querySelector('[data-reviews-list]');
      var per = parseInt(list.getAttribute('data-per-page'), 10) || 6;
      var hidden = $$('[data-review-more][hidden]', list);
      hidden.slice(0, per).forEach(function (el) { el.hidden = false; });
      if (hidden.length <= per) btn.parentNode.hidden = true;
    });
  });

  /* ---------- Cupom de presente ---------- */
  var gift = $('[data-gift]');
  var giftModal = gift ? $('[data-gift-modal]', gift) : null;
  var giftBubble = gift ? $('[data-gift-bubble]', gift) : null;
  var KEY = 'flowGiftSeen';

  function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function openGift() {
    if (!giftModal) return;
    giftModal.hidden = false;
    if (giftBubble) giftBubble.hidden = true;
    lock();
  }
  function closeGift() {
    if (!giftModal || giftModal.hidden) return;
    giftModal.hidden = true;
    unlock();
  }

  if (gift && !seen() && !document.querySelector('[data-cart-page]')) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var useBubble = isMobile && gift.getAttribute('data-mobile-bubble') === 'true';
    var threshold = parseInt(gift.getAttribute('data-scroll'), 10) || 0;
    var trigger = function () {
      if (window.scrollY < threshold) return;
      window.removeEventListener('scroll', trigger);
      markSeen();
      if (useBubble) { giftBubble.hidden = false; } else { openGift(); }
    };
    window.addEventListener('scroll', trigger, { passive: true });
    trigger();
  }
  if (gift) {
    if (giftBubble) giftBubble.addEventListener('click', openGift);
    $$('[data-gift-close]', gift).forEach(function (b) { b.addEventListener('click', closeGift); });
    var copyBtn = $('[data-gift-copy]', gift);
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = gift.getAttribute('data-code');
        var done = function () {
          var l = $('[data-gift-copy-label]', copyBtn);
          if (l) l.textContent = T.strings.copied;
        };
        if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
      });
    }
  }

  /* ---------- Animações ao rolar ---------- */
  var motion = document.documentElement.classList.contains('motion');
  var replay = document.body.getAttribute('data-replay') === 'true';

  /* Letras do banner entram uma a uma */
  $$('[data-split]').forEach(function (el) {
    if (!motion || el.getAttribute('data-split-done')) return;
    var text = el.textContent;
    el.textContent = '';
    Array.prototype.forEach.call(text, function (ch, i) {
      var span = document.createElement('span');
      span.className = 'ch';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--i', i);
      span.textContent = ch === ' ' ? ' ' : ch;
      el.appendChild(span);
    });
    el.setAttribute('data-split-done', '1');
  });

  /* Título gigante do banner nunca passa da largura da tela */
  function fitTitles() {
    $$('.hx__title').forEach(function (el) {
      el.style.fontSize = '';
      var box = el.parentNode.clientWidth - 8;
      var size = parseFloat(getComputedStyle(el).fontSize);
      var guard = 0;
      while (el.scrollWidth > box && size > 28 && guard < 60) {
        size -= 4;
        el.style.fontSize = size + 'px';
        guard++;
      }
    });
  }
  fitTitles();
  window.addEventListener('resize', fitTitles);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);

  /* O que aparece ao rolar: [seletor, tipo, atraso em sequência entre irmãos] */
  var REVEAL = [
    ['.section-head', '', false],
    ['.grid > *', '', true],
    ['.story__media', 'clip', false],
    ['.story__copy', '', false],
    ['.spotlight__copy > *', '', true],
    ['.spotlight__media', 'clip', false],
    ['.about-video__copy > *', '', true],
    ['.about-video__media', 'fade', false],
    ['.trust__item', '', true],
    ['.highlights__grid > *', '', true],
    ['.acc-list > *', '', true],
    ['.reviews__summary', 'scale', false],
    ['.reviews__list > *', '', true],
    ['.faq__box', '', false],
    ['.contact-strip__content > *', '', true],
    ['.panels__row > .panel', 'clip', true],
    ['.editorial__copy > *', '', true],
    ['.editorial__img', 'clip', true],
    ['.footer__col', '', true],
    ['.footer__brand', 'scale', false],
    ['.hx__content > *:not(.hx__title)', '', true],
    ['.hx__card', 'fade', false],
    ['.product .trust__item', '', true],
    ['.cart-trending .grid > *', '', true]
  ];

  if (motion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          if (!replay) io.unobserve(entry.target);
        } else if (replay && entry.boundingClientRect.top > 0) {
          entry.target.classList.remove('is-in');
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    REVEAL.forEach(function (rule) {
      $$(rule[0]).forEach(function (el) {
        if (el.classList.contains('reveal') || el.closest('.drawer, .gift, .product__info')) return;
        el.classList.add('reveal');
        if (rule[1]) el.classList.add('reveal--' + rule[1]);
        if (rule[2]) {
          var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
          el.style.setProperty('--reveal-delay', Math.min(idx, 8) * 0.09 + 's');
        }
        io.observe(el);
      });
    });
  }

  /* Parallax suave */
  var parallaxOn = motion && document.body.getAttribute('data-parallax-enabled') === 'true';
  var pEls = parallaxOn ? $$('[data-parallax]') : [];
  if (pEls.length) {
    var ticking = false;
    var runParallax = function () {
      var vh = window.innerHeight;
      pEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0;
        var offset = (r.top + r.height / 2 - vh / 2) * speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(runParallax); }
    }, { passive: true });
    runParallax();
  }

  /* Banner: fotos trocam sozinhas */
  $$('[data-hx]').forEach(function (hx) {
    var slides = $$('.hx__slide', hx);
    var dots = $$('.hx__dot', hx);
    if (slides.length < 2) return;
    var i = 0;
    var ms = (parseInt(hx.getAttribute('data-interval'), 10) || 5) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }, ms);
  });

  /* Recuperar senha (página de login) */
  $$('[data-recover-toggle]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var box = document.getElementById('recover');
      if (box) box.scrollIntoView({ behavior: 'smooth' });
    });
  });
})();
